<template>
  <div class="match-card match-card__no-user-media text-center">
    <div class="match-card__desc">
      <div class="title title--large title--white">
        {{ trans.get('pages:match_game.no_image_card.header') }}
      </div>

      <div class="desc desc--white my-1">
        {{ trans.get('pages:match_game.no_image_card.desc') }}
      </div>
    </div>

    <div class="avatar-with-button">
      <div class="avatar-with-button__image">
        <router-link :to="{name: 'user.edit', query: {highlight: '.js-image-add-modal'}}">
          <div
            class="avatar-with-button__image-inner"
            :style="{'background-image':'url(' + user.web_avatar_url + '?h=350)'}"
          >
          </div>
        </router-link>

        <div class="avatar-with-button__edit">
          <router-link :to="{name: 'user.edit', query: {highlight: '.js-image-add-modal'}}">
            <div class="avatar-with-button__edit-inner"><i class="demo-icon icon-pencil"></i></div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="match-card__button">
      <router-link
        :to="{name: 'user.edit'}"
        class="button button__outline button__outline--white-hov-purple"
      >
        {{ trans.get('pages:match_game.no_image_card.go_to_profile_button') }}
      </router-link>
    </div>
    <div class="mmatch-card__button">
      <button v-on:click="emitNext()" class="button button__link--underline button__link--white">
        {{ trans.get('pages:match_game.no_image_card.skip_button') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NoUserMediaCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {
    emitNext() {
      this.$emit('input', { visible: false, });
      this.$emit('next', 'NEXT');
    },
  },
  mounted() {
  }
};
</script>


